import * as apiTo from '@/modular-api'
import { Dialog } from 'quasar'
import ConfirmationDialog from '@/reusable/ConfirmationDialog/ConfirmationDialog'

export async function deleteAgGridRow({ data: { id } }, confirmationRequest, deleteRequest, onDeleted) {
  const { data } = await apiTo[confirmationRequest](id)
  Dialog.create({
    component: ConfirmationDialog,
    title: 'Confirm',
    messages: data.messages.default
  }).onOk(() => {
    apiTo[deleteRequest](id).then(onDeleted)
  })
}
